import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";
import useCalendarSale from "../CalendarSale/hooks/useCalendarSale";
import SingleAvailAbleExercise from "../CalendarSale/single-exercise";
import useFacility from "../../../utils/hooks/useFacility";
import useTickets from "../LimitedTicket/hooks/useTickets";
import LimitedTicketBlock from "../LimitedTicket/LimitedTicketBlock";
import usePasses from "../Passes/hooks/usePasses";
import "../CustomOffer/CustomOffer.scss";
import SinglePass from "../Passes/SinglePass";

const OfferShowcase: React.FC = () => {
  const { getExercisesAvailable, exerciseAvailAble } = useCalendarSale();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const facilityIds = useFacility();
  const { colorGroup, requestGetColorGroups } = useTickets();
  const { passes, selectedDate, setDateBetween } = usePasses();
  useEffect(() => {
    getExercisesAvailable();
    requestGetColorGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);
  return (
    <>
      <EAPageHeader componentId="StepByStepSaleActiveV2" />
      <EAPageMessage message={saleConfiguration.message_stepByStep} />

      <div className="offer-products-list">
        {/* 
          Ten komponent powstał na szybko aby  obsłużyc jednego klienta, 
          na razie pokazujemy tylko CalendaSale oraz ColorSale
          */}

        {exerciseAvailAble && (
          <>
            {exerciseAvailAble.map((item, index) => (
              <SingleAvailAbleExercise exercise={item} key={index} />
            ))}
          </>
        )}

        {colorGroup && (
          <>
            {colorGroup.map((item, index) => (
              <LimitedTicketBlock item={item} sortType="colorGroup" key={index} />
            ))}
          </>
        )}

        {passes && (
          <>
            {passes.map((item) => (
              <SinglePass
                key={item.objectId}
                item={item}
                selectedDate={selectedDate}
                setDateBetween={setDateBetween}
                isHorizontal
              />
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default OfferShowcase;
